import { render } from "./UserNavigation.vue?vue&type=template&id=cce3470e"
import script from "./UserNavigation.vue?vue&type=script&lang=js"
export * from "./UserNavigation.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-MyFirstBusiness\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__